export default "__VITE_ASSET__D9d80eEk__"